var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "withdrawalForm",
    class: "pb-4"
};
const _hoisted_2 = {
    class: "row",
    id: "withdrawal_content"
};
const _hoisted_3 = { class: "col-12 p-0 pb-3" };
const _hoisted_4 = { class: "col-12 p-0 pb-3" };
const _hoisted_5 = { class: "col-12 p-0 pb-3" };
const _hoisted_6 = { class: "col-12 p-0 pb-1" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-4 offset-4 mt-lg-0 mt-3" };
const _hoisted_9 = ["disabled"];
import { emailRequiredRule, firstNameRule, lastNameRule, stringRequiredRule } from '@/helpers/ValidationRules';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import { computed, onMounted, ref } from 'vue';
import axios from 'axios';
import eventBus from '@/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WithdrawalForm',
    props: {
        firstName: { type: String, required: false, default: '' },
        lastName: { type: String, required: false, default: '' },
        email: { type: String, required: false, default: '' },
    },
    setup(__props) {
        const props = __props;
        const firstName = ref(props.firstName);
        const lastName = ref(props.lastName);
        const email = ref(props.email);
        const orderNumber = ref('');
        const firstNameValid = ref(false);
        const lastNameValid = ref(false);
        const emailValid = ref(false);
        const orderNumberValid = ref(false);
        const submitPossible = computed(() => {
            return firstNameValid.value && lastNameValid.value && emailValid.value && orderNumberValid.value;
        });
        onMounted(() => {
            firstNameValid.value = firstName.value.length > 0;
            lastNameValid.value = lastName.value.length > 0;
            emailValid.value = email.value.length > 0;
        });
        const send = () => __awaiter(this, void 0, void 0, function* () {
            if (!submitPossible.value) {
                return;
            }
            axios
                .post('/widerruf', {
                type: 'basic',
                first_name: firstName.value,
                last_name: lastName.value,
                email: email.value,
                order_number: orderNumber.value,
            })
                .then(() => {
                location.href = '/widerruf_success';
            })
                .catch((error) => {
                let serverResponseErrors = '';
                Object.values(error.response.data.errors).forEach((e) => {
                    serverResponseErrors += e;
                    serverResponseErrors += '<br>';
                });
                eventBus.emit('openInfoPopup', {
                    icon: 'error',
                    headline: 'Da ging was schief',
                    message: serverResponseErrors,
                });
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(BaseInput, {
                            class: "showValidationErrorsCssOverride",
                            rules: _unref(firstNameRule),
                            modelValue: firstName.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((firstName).value = $event)),
                            placeholder: "Vorname *",
                            name: "firstName",
                            onChanged: _cache[1] || (_cache[1] = (event) => (firstNameValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(BaseInput, {
                            class: "showValidationErrorsCssOverride",
                            rules: _unref(lastNameRule),
                            modelValue: lastName.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((lastName).value = $event)),
                            placeholder: "Nachname *",
                            name: "lastName",
                            onChanged: _cache[3] || (_cache[3] = (event) => (lastNameValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(BaseEmailInput, {
                            class: "showValidationErrorsCssOverride",
                            rules: _unref(emailRequiredRule),
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((email).value = $event)),
                            placeholder: "E-Mail *",
                            label: "",
                            id: "email",
                            name: "email",
                            onChanged: _cache[5] || (_cache[5] = (event) => (emailValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(BaseInput, {
                            class: "showValidationErrorsCssOverride",
                            rules: _unref(stringRequiredRule),
                            modelValue: orderNumber.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((orderNumber).value = $event)),
                            placeholder: "Bestellnummer *",
                            name: "orderNumber",
                            onChanged: _cache[7] || (_cache[7] = (event) => (orderNumberValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"])
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "font8-responsive text-left pb-4" }, "* Pflichtangabe", -1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                            disabled: !submitPossible.value,
                            class: _normalizeClass([{ buttonDisabled: !submitPossible.value }, "buttonBase buttonGreen w-100"]),
                            type: "button",
                            onClick: send
                        }, " Widerruf absenden ", 10, _hoisted_9)
                    ])
                ])
            ]));
        };
    }
});
